// import { getEidList } from '../apis/cmsApi';
import { pageRenderer } from '../components/renderer';
export var __N_SSP = true;
export default function Renderer(props) {
    return pageRenderer(props);
};
